import React from 'react';
import PropTypes from 'prop-types';
import { StyledContentDivider } from './ContentDivider.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

function ContentDivider(props) {
  const { before, after, children, theme } = props;

  const position = [before && '&:before', after && '&:after'].filter(Boolean).join(', ');

  return (
    <StyledContentDivider theme={theme} position={position}>
      {children}
    </StyledContentDivider>
  );
}

ContentDivider.propTypes = {
  /** adds divide line before content */
  before: PropTypes.bool,
  /** adds divide line after content */
  after: PropTypes.bool,
  /** Components to live inside divider - between the divide lines */
  children: ReactChildrenPropType,
  /** Theme prop */
  theme: PropTypes.oneOf(['default', 'hr'])
};

ContentDivider.defaultProps = {
  before: false,
  after: false,
  children: null,
  theme: 'default'
};

export default ContentDivider;
